import { getValue, isPending } from 'mobx-async'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter, useIsTabletOrMobile } from '@avantstay/backoffice-core'

import { RegionsFilter as MainRegionsFilter } from '@new/__global/components/RegionsFilter'

import { RegionsStore } from '@stores/RegionsStore'

import { FiltersSharedProps } from './Filters.types'

interface RegionsFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  title?: string
  hideSelectAllOption?: boolean
  hideClearButton?: boolean
  className?: string
}

export const RegionsFilter: FC<RegionsFilterProps> = observer(
  ({
    isSidebarFilter,
    isAccordionOpen,
    hideSelectAllOption,
    title,
    onChange,
    hideClearButton,
    ...props
  }) => {
    const regions = getValue(RegionsStore.regions)
    const isLoadingOptions = isPending(RegionsStore.regions)

    const isTabletOrMobile = useIsTabletOrMobile()

    const regionsOptions =
      regions?.map(({ id, name, homeCount }) => ({
        value: id,
        hasFullWidth: true,
        label: (
          <>
            {name}
            <span style={{ marginLeft: 'auto' }}>{homeCount}</span>
          </>
        ),
        searchLabel: name,
      })) || []

    return isTabletOrMobile || isSidebarFilter ? (
      <CheckboxBasedFilter
        title={title || 'Markets'}
        alwaysShowAll={!hideSelectAllOption}
        hideSelectAllOption={hideSelectAllOption}
        isLoadingOptions={isLoadingOptions}
        options={regionsOptions}
        searchPlaceholder="Search by market"
        onChange={onChange}
        {...props}
        isSearchEnabled
        isAccordionOpen={isAccordionOpen}
        shouldShowClearButton={!hideClearButton}
      />
    ) : (
      <MainRegionsFilter
        {...props}
        hideSelectAllOption={hideSelectAllOption}
        onChange={isSidebarFilter ? () => {} : onChange}
      />
    )
  },
)
